import React from 'react';
import loadable from '@loadable/component';
import Masonry from 'react-masonry-component';

import Slider from 'react-slick';
import CritterCuddler from '../../../assets/images/crittercuddler-circle.png';
import SuzzneCatJpg from '../../../assets/images/products/reviews/CC/Suzzne-cat.jpg';
import SuzzneCatWebp from '../../../assets/images/products/reviews/CC/Suzzne-cat.jpg?as=webp';
import GeorgeMp4 from '../../../assets/images/products/reviews/CC/George.mp4';
import GeorgeWebm from '../../../assets/images/products/reviews/CC/George.webm';

import CCBalloonLg from '../../../assets/images/products/reviews/CC/cc-balloon-lg.png';
import CCBalloonMd from '../../../assets/images/products/reviews/CC/cc-balloon-md.png';
import CCBalloonSm from '../../../assets/images/products/reviews/CC/cc-balloon-sm.png';

const ImageLoader = loadable(() => import('../common/ImageLoader'));

const baloons = {
  lgUrl: CCBalloonLg,
  mdUrl: CCBalloonMd,
  smUrl: CCBalloonSm,
};

const reviewItems = [{
  name: 'Linda',
  subTitle: 'A Critter Cuddler',
  description: () => (<p>We love Mila. Wish she had joined our family sooner. Plan to buy her a sibling for our upstairs in the near future.</p>),
  image: null,
},
{
  name: 'Suzanne',
  subTitle: 'A Critter Cuddler',
  description: () => (<p>I can’t believe what a difference Mila has made in my bedroom! I sleep so much better and my sinus headaches have practically disappeared. Even my kitty’s allergies are better. I’m just sorry I waited so long to purchase this. Also, I like that it’s so whispered quiet and can be tucked away in the corner. ❤️</p>),
  image: {
    isGif: false,
    baseUrl: SuzzneCatJpg,
    webpUrl: SuzzneCatWebp,
  },
},
{
  name: 'George + Mallow',
  subTitle: 'A Critter Cuddler',
  description: () => (
    <p>
      It’s like a magic box that makes the sneezes go away ... thanks Mila for keeping our home allergy free! 🥰
    </p>
  ),
  image: {
    isVideo: true,
    mp4Url: GeorgeMp4,
    webmUrl: GeorgeWebm,
  },
},
{
  name: 'Duffy',
  subTitle: 'A Critter Cuddler',
  description: () => (<p>I want to buy one for each family member of mine. I have a cat with respiratory issues and I can see a difference in her breathing. I also have asthma and severe allergies and let me tell ya, my lungs are happy campers! </p>),
  image: null,
},
];

const ReviewItem = ({
  name, subTitle, description, image,
}) => (
  <div className='product-reviews__item'>
    <div className='product-review'>
      <div className='product-review__header'>
        <figure className='product-review__profile-image'>
          <img src={CritterCuddler} alt={name} />
        </figure>
        <div className='product-review__header-content'>
          <h4 className='product-review__name'>{name}</h4>
          <span className='product-review__designation'>{subTitle}</span>
        </div>
      </div>
      <div className='product-review__body'>
        {description()}
        {image && (
          image.isVideo ? (
            <video
              className='product-review__image img-relative'
              style={{ aspectRatio: '330 / 440' }}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              aria-label={`${name} ${subTitle}`}
            >
              <source src={image.webmUrl} type="video/webm" />
              <source src={image.mp4Url} type="video/mp4" />
            </video>
          ) : (
            <ImageLoader
              className='product-review__image img-relative'
              placeholderAspectRatio={330 / 440}
              image={image.baseUrl}
              webp={image.webpUrl}
              alt={`${name} ${subTitle}`}
            />
          )
        )}
      </div>
    </div>
  </div>
);

const ReviewsGrid = () => {
  const settings = {
    variableWidth: true,
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [{
      settings: {
        adaptiveHeight: true,
      },
    }],
  };
  return (
    <>
      <Masonry columns={3} className='product-reviews__grid product-reviews__grid--masonry'>
        {reviewItems.map(reviewItem => (<ReviewItem key={reviewItem.name} {...reviewItem} />))}
      </Masonry>
      <Slider className='product-reviews__grid product-reviews__grid--slider' {...settings}>
        {reviewItems.map(reviewItem => (<ReviewItem key={reviewItem.name} {...reviewItem} />))}
      </Slider>
    </>
  );
};

const ProductReviews = () => (
  <div className='product-reviews' style={{ '--primary-color': ' #F42D53', '--secondary-color': '#FFF2F5' }}>
    <div className='container container--md'>

      <h2 className='product-reviews__title'>
        Powering cleaner air for
        {' '}
        <span>15,000+</span>
        {' '}
        fur families
      </h2>
      <div className='product-reviews__wrapper'>
        <img src={baloons.lgUrl} alt='Large balloon' className='product-reviews__balloon product-reviews__balloon--lg' />
        <img src={baloons.mdUrl} alt='Medium balloon' className='product-reviews__balloon product-reviews__balloon--md' />
        <img src={baloons.smUrl} alt='Small balloon' className='product-reviews__balloon product-reviews__balloon--sm' />
        <ReviewsGrid />
      </div>
    </div>
  </div>
);

export default ProductReviews;
